module.exports = __webpack_public_path__ + "2ed2cb0ef644168dacbe36de1ced34f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/media/9/9.jpg
// module id = 586
// module chunks = 0